<template>
  <section class="login-container">
     <div class="page-content">
      <div class="panel">
        <div class="panel-body">
          <div class="brand">
            <img class="brand-img" src="../assets/img/logo-olli.png" width="100" style="border-radius: 50%">
           <h1 class="brand-text">Welcome to Skill Builder</h1>
          </div>
          <el-form :model="connect.data" autoComplete="on" status-icon label-position="left" label-width="0px" class="login-form" :rules="rules" ref="loginForm"
          @submit.native.prevent="handleConnect">
            <el-form-item prop="email">
              <el-input
                tabindex="1"
                prefix-icon="el-icon-fa-envelope"
                name="email"
                type="text"
                autoComplete="on"
                placeholder="Email"
                v-model.trim="connect.data.email"
                autofocus />
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                tabindex="2"
                prefix-icon="el-icon-fa-key"
                name="password"
                type="password"
                placeholder="Password"
                v-model="connect.data.password"
                @keyup.enter.native="handleLogin" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" native-type="submit" style="width:100%;">Login</el-button>
            </el-form-item>
            <el-form-item>
              <a class="link-register" href="/?#/register">Not a member yet? Register now!</a>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import State from '../stores/state.js'
export default {
  name: 'Login',

  data () {
    return {
      state: State.state,
      connect: {
        loading: false,
        visible: false,
        data: {
          email: '',
          password: '',
          password_confirm: '',
        },
        create: false,
      },
      refs: {
        loginForm: HTMLFormElement,
      },
      rules: {
        email: [
          {
            type: 'email',
            required: true,
            message: 'Email is invalid',
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: 'Password is required',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  watch: {
    'state.error' (error) {
      if (!error) return
      else if (error.status === 401) {
        this.$message({
          message: 'Not connected',
          type: 'error',
        })
        this.connect.visible = true
      }
    },
    'connect.visible' () {
      this.connect.data.password = ''
      this.connect.data.password_confirm = ''
      this.connect.create = false
    },
    'state.user' (user) {
      if (user) this.connect.visible = false
    },
  },
  methods: {
    handleConnect () {
      this.connect.loading = true
      if (this.connect.create) {
        State.createUser({
          email: this.connect.data.email,
          password: this.connect.data.password,
          role: 'client',
          infos: {},
          authorizations: {},
        }).then(() => {
          this.$message({
            message: 'user created, you can login',
            type: 'success',
          })
          this.connect.create = false
        }, error => this.onerror(error, 'Error on connection'))
          .finally(() => { this.connect.loading = false })
      } else {
        State.connect({
          email: this.connect.data.email,
          password: this.connect.data.password,
        }).then(user => {
          this.$message({
            message: 'Connected on ' + user.email,
            type: 'success',
          })
          this.connect.visible = false
          this.$router.push(this.$route.query.next || '/')
        }, error => this.onerror(error, 'Error on connection'))
          .finally(() => { this.connect.loading = false })
      }
    },
    handleDisconnect () {
      State.disconnect().then(() => {
        this.$message({
          message: 'Disconnected',
          type: 'success',
        })
      }, this.onerror)
    },
    onerror (error, prefix) {
      console.error(error)
      prefix = prefix || 'Error'
      let message = error.responseJSON
        ? error.responseJSON.errors.join(', ') : error
      this.$message({
        message: prefix + ': ' + message,
        type: 'error',
      })
    },
  },
}
</script>
<style lang="scss">

html,
body {

  .login-container {
    width: 100%;
    height: 100vh;
    font-weight: 100;
    background-image: url('../assets/img/bg_login.jpg');
    background-repeat: repeat-x;
    background-position: center top;
    -webkit-background-size: cover;
    background-size: cover;

    .page-content {
      text-align: center;
      display: flex;
      align-items: center;
      width: 100%;
      height: 100vh;
      justify-content: center;

      .panel {
        width: 400px;
        margin-bottom: 45px;
        background: #fff;
        border-radius: 4px;
        display: inline-block;
        vertical-align: middle;

        .panel-body {
          padding: 50px 40px 40px;
          min-height: 100%;
          max-height: 100%;

          .brand-text {
            font-size: 22px;
            font-weight: bold;
            text-shadow: rgba(0, 0, 0, 0.15) 0 0 1px;
          }
          .login-form {
            margin: 30px 30px 0;

            .el-form-item {
              margin-bottom: 22px;
            }
          }
        }
      }
    }
  }
  .link-register {
    text-decoration: none;
    color: #ff0033;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
